import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ModalComponent from '../../../sharedLegacy/components/ModalComponent/ModalComponent'
import BigLoaderComponent from '../../../sharedLegacy/components/BigLoaderComponent/BigLoaderComponent'
import CamPermissionsPromptComponent from '../../../sharedLegacy/components/CamPermissionsPromptComponent/CamPermissionsPromptComponent'

import './WebinarConnectingComponent.scss'

const renderContent = (showPermissionsHint, loadingText) => {
  if (showPermissionsHint) {
    return (
      <CamPermissionsPromptComponent
        productName="TwentyThree Webinars"
        showMuteNotice
      />
    )
  }

  return <BigLoaderComponent loadingText={loadingText} />
}

const WebinarConnectingComponent = ({
  isModalOpen,
  showPermissionsHint,
  loadingText,
}) => {
  return (
    <ModalComponent
      wrapClassName={classnames('webinar-connecting-component', {
        transparent: !showPermissionsHint,
      })}
      visible={isModalOpen}
      overlayTransparency="opaque"
      maskStyle={{
        backgroundColor: '#222',
      }}
      style={{
        top: '0',
      }}
      maskClosable={false}
      closable={false}
      key={showPermissionsHint}
      width={710}
    >
      {renderContent(showPermissionsHint, loadingText)}
    </ModalComponent>
  )
}

WebinarConnectingComponent.propTypes = {
  isModalOpen: PropTypes.bool,
  showPermissionsHint: PropTypes.bool,
  loadingText: PropTypes.string,
}

export default WebinarConnectingComponent
